import styled from 'styled-components';
import Heading from 'core/components/Heading';

const Title = styled(Heading)`
	margin: 0;
	font-weight: 700;
	font-size: 18px;
	letter-spacing: -0.4px;
	margin-bottom: 24px;
`;

export default Title;
